module.exports = __webpack_public_path__ + "static/media/35.1c215198.jpg";